
export default {
    props: {
        roles: {
            type: Array,
            defualt: () => {}
        }
    },
}
